export default {
  title: 'Ayuda',
};
